import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import elementExists from "../utils/elementExists";
import Lottie from "lottie-web";

const MicroAnimation = function () {

    // START Header Content Section //
    let headerContent = document.querySelectorAll('.header-content');
    if ( elementExists(headerContent, true) ) {
        gsap.registerPlugin(ScrollTrigger);        
        headerContent.forEach((section, i) => {
            let headerEls = section.querySelectorAll('.header-content__gsap');
            ScrollTrigger.matchMedia({
                "(min-width: 992px)": function() {
                    function animHeaderContent () {
                        headerEls.forEach((el, i) => {
                            el.classList.add('gsap-on');
                            el.style.transitionDelay = (i * 0.15) + 's';
                        });
                    }
                    let timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: section,
                            onEnter: animHeaderContent,
                            start: "0% 75%",
                            end: "100% 75%",
                            scrub: 0.5,
                            // markers: true
                        }
                    });
                    timeline.to(
                        headerEls,
                        {   
                            duration: 1,
                        }   
                    );
                },
                "(max-width: 992px)": function() {
                    function animHeaderContent () {
                        headerEls.forEach((el, i) => {
                            el.classList.add('gsap-on');
                            el.style.transitionDelay = (i * 0.15) + 's';
                        });
                    }
                    let timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: section,
                            onEnter: animHeaderContent,
                            start: "0% 90%",
                            end: "100% 90%",
                            scrub: 0.5,
                            // markers: true
                        }
                    });
                    timeline.to(
                        headerEls,
                        {   
                            duration: 1,
                        }   
                    );
                },
            });
        });   
        // // Help visibility for headers in the theme editor
        // document.addEventListener( 'shopify:section:load', function( evt ){
        //     console.log( evt )
        //     let headerEls = document.querySelectorAll('.header-content__gsap');
        //     headerEls.forEach( el => {
        //         el.classList.add('gsap-on');
        //     })
        // })
    }
    // END Header Content Section //


    // START Product Callout //
    let productCallout = document.querySelectorAll('.product-callout-slider');
    if ( elementExists( productCallout, true ) ) {
        gsap.registerPlugin(ScrollTrigger);        
        productCallout.forEach((section, i) => {
            let cards = section.querySelectorAll('.swiper-slide');
            ScrollTrigger.matchMedia({
                "(min-width: 992px)": function() {
                    function animProductCallout () {
                        cards.forEach((card, i) => {
                            card.classList.add('gsap-on');
                            card.style.transitionDelay = (i * 0.25) + 's';
                        });
                    }
                    let timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: section,
                            onEnter: animProductCallout,
                            start: "0% 75%",
                            end: "100% 75%",
                            scrub: 0.5,
                            // markers: true
                        }
                    });
                    timeline.to(
                        cards,
                        {   
                            duration: 1,
                        }   
                    );
                }
            });
        });
    }


    // START Two Column Panels //
    let twoColumnPanels = document.querySelectorAll('.two-column-panels');
    if ( elementExists( twoColumnPanels, true ) ) {
        gsap.registerPlugin(ScrollTrigger);        
        twoColumnPanels.forEach((section, i) => {
            let cards = section.querySelectorAll('.two-column-panels__block');
            function animTwoColumnPanels () {
                cards.forEach((card, i) => {
                    card.classList.add('gsap-on');
                    card.style.transitionDelay = (i * 0.25) + 's';
                });
            }
            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    onEnter: animTwoColumnPanels,
                    start: "0% 65%",
                    end: "100% 65%",
                    scrub: 0.5,
                    // markers: true
                }
            });
            timeline.to(
                cards,
                {       
                    duration: 1,
                }   
            );
        });
    }

    // START Testimonials //
    let testionialsSection = document.querySelectorAll('.page-section-testimonials');
    if ( elementExists( testionialsSection, true ) ) {
        gsap.registerPlugin(ScrollTrigger);        
        testionialsSection.forEach((section, i) => {
            let els = section.querySelectorAll('.gsap-el');
            function animTestimonials () {
                els.forEach((el, i) => {
                    el.classList.add('gsap-on');
                    el.style.transitionDelay = (i * 0.25) + 's';
                });
            }
            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    onEnter: animTestimonials,
                    start: "0% 50%",
                    end: "100% 50%",
                    scrub: 0.5,
                    // markers: true
                }
            });
            timeline.to(
                els,
                {   
                    duration: 1,
                }   
            );
        });
    }


    


    ////// LOTTIE ANIMATIONS //////

    // Header Content //
    let lotties = document.querySelectorAll('.lottie-container');

    if ( elementExists( lotties, true ) ) {
        gsap.registerPlugin(ScrollTrigger);        
        lotties.forEach((lottie, i) => {
            let lottieAnimation = lottie.getAttribute('data-lottie');
            function playLottie () {
                var animation = Lottie.loadAnimation({
                    container: lottie,
                    path: lottieAnimation,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                });
            }

            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: lottie,
                    onEnter: playLottie,
                    start: "0% 100%",
                    end: "100% 100%",
                    scrub: 0.5,
                    once: true,
                    // markers: true
                }
            });
        });
    }

}

export default MicroAnimation;
